import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable, Select } from '@macs-frontend/decorators';
import { Store } from '@ngrx/store';
import {
  ClearAsyncErrorAction,
  FormGroupState,
  StartAsyncValidationAction,
} from 'ngrx-forms';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as authActions from '../../actions/auth.actions';
import * as fromAuth from '../../reducers/index';

@Component({
  selector: 'md-send-email',
  templateUrl: './send-email.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SendEmailComponent extends BaseComponent implements OnDestroy {
  @Select(fromAuth.getLoginForm)
  // @ts-expect-error
  loginForm$: Observable<FormGroupState<fromAuth.LoginForm>>;
  // @ts-expect-error
  formId: string;

  sendResetLink() {
    this.store$.dispatch(new authActions.SendEmail());
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.store$.dispatch(new StartAsyncValidationAction(this.formId, 'notFound'));
    this.store$.dispatch(new ClearAsyncErrorAction(this.formId, 'notFound'));
  }

  constructor(
    readonly store$: Store<fromAuth.AuthState>,
    readonly cdr: ChangeDetectorRef,
  ) {
    super();
    makeSelectable(this, { cdr, store$ });
    // @ts-expect-error
    this.loginForm$
      .pipe(takeUntil(this.destroy$))
      .subscribe((form: FormGroupState<fromAuth.LoginForm>) => (this.formId = form.id));
  }
}
